/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_Get_Started_AriaInputs */

const en_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started with a free account`)
};

const de_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos mit einem Konto starten`)
};

const fr_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer avec un compte gratuit`)
};

const es_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar con una cuenta gratuita`)
};

const it_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia con un account gratuito`)
};

const nl_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin met een gratis account`)
};

const pl_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij z darmowym kontem`)
};

const fi_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita ilmaisella tilillä`)
};

const da_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom i gang med en gratis konto`)
};

const sv_landing_cta_get_started_aria = /** @type {(inputs: Landing_Cta_Get_Started_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom igång med ett gratis konto`)
};

/**
* | output |
* | --- |
* | "Get started with a free account" |
*
* @param {Landing_Cta_Get_Started_AriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_cta_get_started_aria = /** @type {((inputs?: Landing_Cta_Get_Started_AriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_Get_Started_AriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_cta_get_started_aria(inputs)
	if (locale === "fr") return fr_landing_cta_get_started_aria(inputs)
	if (locale === "es") return es_landing_cta_get_started_aria(inputs)
	if (locale === "it") return it_landing_cta_get_started_aria(inputs)
	if (locale === "nl") return nl_landing_cta_get_started_aria(inputs)
	if (locale === "pl") return pl_landing_cta_get_started_aria(inputs)
	if (locale === "fi") return fi_landing_cta_get_started_aria(inputs)
	if (locale === "da") return da_landing_cta_get_started_aria(inputs)
	if (locale === "sv") return sv_landing_cta_get_started_aria(inputs)
	return en_landing_cta_get_started_aria(inputs)
});